import React, { useState } from 'react';
import { PageHeader } from './PageHeader';
import './SettingsPage.css';

export const ThemePage: React.FC = () => {
  const [selectedTheme, setSelectedTheme] = useState<'light' | 'dark' | 'auto'>('light');

  return (
    <div className="page-container settings-page">
      <PageHeader title="Темная тема" />

      <div className="settings-content">
        <div className="settings-group">
          <h2 className="settings-group-title">Оформление</h2>
          <div className="theme-options">
            <button 
              className={`theme-option ${selectedTheme === 'light' ? 'active' : ''}`}
              onClick={() => setSelectedTheme('light')}
            >
              <div className="theme-icon">☀️</div>
              <div className="theme-label">Светлая</div>
              {selectedTheme === 'light' && <div className="theme-checkmark">✓</div>}
            </button>
            <button 
              className={`theme-option ${selectedTheme === 'dark' ? 'active' : ''}`}
              onClick={() => setSelectedTheme('dark')}
            >
              <div className="theme-icon">🌙</div>
              <div className="theme-label">Темная</div>
              {selectedTheme === 'dark' && <div className="theme-checkmark">✓</div>}
            </button>
            <button 
              className={`theme-option ${selectedTheme === 'auto' ? 'active' : ''}`}
              onClick={() => setSelectedTheme('auto')}
            >
              <div className="theme-icon">🔄</div>
              <div className="theme-label">Авто</div>
              {selectedTheme === 'auto' && <div className="theme-checkmark">✓</div>}
            </button>
          </div>
          <p className="settings-note">
            Тема "Авто" будет следовать системным настройкам вашего устройства
          </p>
        </div>
      </div>
    </div>
  );
};

